module.exports = __webpack_public_path__ + "static/assets/66a02cdd25d6b706fbca03704ab31cba.png";